export const PermissionsV2 = {
  VIEW_MERCHANTS: 'VIEW_MERCHANTS',
  VIEW_MERCHANT_INFORMATION: 'VIEW_MERCHANT_INFORMATION',
  EDIT_MERCHANT_INFORMATION: 'EDIT_MERCHANT_INFORMATION',
  VIEW_KYC_DOCUMENTS: 'VIEW_KYC_DOCUMENTS',
  VIEW_MERCHANT_CORRIDOR_MANAGEMENT: 'VIEW_MERCHANT_CORRIDOR_MANAGEMENT',
  MANAGE_MERCHANT_CORRIDOR_MANAGEMENT: 'MANAGE_MERCHANT_CORRIDOR_MANAGEMENT',
  CREATE_MERCHANT_CORRIDOR_MANAGEMENT: 'CREATE_MERCHANT_CORRIDOR_MANAGEMENT',
  VIEW_ADD_ACCOUNT_ACCOUNT_CONFIGS: 'VIEW_ADD_ACCOUNT_ACCOUNT_CONFIGS',
  CREATE_ADD_ACCOUNT_ACCOUNT_CONFIGS: 'CREATE_ADD_ACCOUNT_ACCOUNT_CONFIGS',
  VIEW_CORRIDORS_ACCOUNT_CONFIGS: 'VIEW_CORRIDORS_ACCOUNT_CONFIGS',
  MANAGE_CORRIDORS_ACCOUNT_CONFIGS: 'MANAGE_CORRIDORS_ACCOUNT_CONFIGS',
  VIEW_POST_ONBOARDING_ACCOUNT_CONFIGS: 'VIEW_POST_ONBOARDING_ACCOUNT_CONFIGS',
  MANAGE_POST_ONBOARDING_ACCOUNT_CONFIGS: 'MANAGE_POST_ONBOARDING_ACCOUNT_CONFIGS',
  VIEW_OPS_OPERATIONS: 'VIEW_OPS_OPERATIONS',
  VIEW_UNMAPPED_CREDITS_OPERATIONS: 'VIEW_UNMAPPED_CREDITS_OPERATIONS',
  APPROVE_UNMAPPED_CREDITS_OPERATIONS: 'APPROVE_UNMAPPED_CREDITS_OPERATIONS',
  VIEW_WHITELIST_RESOURCES_OPERATIONS: 'VIEW_WHITELIST_RESOURCES_OPERATIONS',
  MANAGE_WHITELIST_RESOURCES_OPERATIONS: 'MANAGE_WHITELIST_RESOURCES_OPERATIONS',
  CREATE_PLACEMENT_ORDERS_OPERATIONS: 'CREATE_PLACEMENT_ORDERS_OPERATIONS',
  VIEW_SETTLEMENT_REPORTS_OPERATIONS: 'VIEW_SETTLEMENT_REPORTS_OPERATIONS',
  VIEW_SUPERMERCHANT_CONFIG_OPERATIONS: 'VIEW_SUPERMERCHANT_CONFIG_OPERATIONS',
  CREATE_SUPERMERCHANT_KYB_CONFIG_OPERATIONS: 'CREATE_SUPERMERCHANT_KYB_CONFIG_OPERATIONS',
  VIEW_KYC_COMPLIANCE_OPERATIONS: 'VIEW_KYC_COMPLIANCE_OPERATIONS',
  MANAGE_KYC_COMPLIANCE_OPERATIONS: 'MANAGE_KYB_COMPLIANCE_OPERATIONS',
  VIEW_KYB_COMPLIANCE_OPERATIONS: 'VIEW_KYB_COMPLIANCE_OPERATIONS',
  MANAGE_KYB_COMPLIANCE_OPERATIONS: 'MANAGE_KYB_COMPLIANCE_OPERATIONS',
  VIEW_CREDITS_IN_REVIEW_COMPLIANCE_OPERATIONS: 'VIEW_CREDITS_IN_REVIEW_COMPLIANCE_OPERATIONS',
  APPROVE_CREDITS_IN_REVIEW_COMPLIANCE_OPERATIONS: 'APPROVE_CREDITS_IN_REVIEW_COMPLIANCE_OPERATIONS',
  VIEW_CREDITS_RFI_REQUESTED_COMPLIANCE_OPERATIONS: 'VIEW_CREDITS_RFI_REQUESTED_COMPLIANCE_OPERATIONS',
  MANAGE_CREDITS_RFI_REQUESTED_COMPLIANCE_OPERATIONS: 'MANAGE_CREDITS_RFI_REQUESTED_COMPLIANCE_OPERATIONS',
  VIEW_DEBIT_TRANSACTIONS_COMPLIANCE_OPERATIONS: 'VIEW_DEBIT_TRANSACTIONS_COMPLIANCE_OPERATIONS',
  VIEW_DEFIT_RFI_REQUESTED_COMPLIANCE_OPERATIONS: 'VIEW_DEFIT_RFI_REQUESTED_COMPLIANCE_OPERATIONS',
  VIEW_TRANSACTION_RISKS_COMPLIANCE_OPERATIONS: 'VIEW_TRANSACTION_RISKS_COMPLIANCE_OPERATIONS',
  MANAGE_TRANSACTION_RISKS_COMPLIANCE_OPERATIONS: 'MANAGE_TRANSACTION_RISKS_COMPLIANCE_OPERATIONS',
  VIEW_PAYMENTS: 'VIEW_PAYMENTS',
  APPROVE_PAYMENTS: 'APPROVE_PAYMENTS',
  CREATE_PAYMENTS: 'CREATE_PAYMENTS',
  MANAGE_MERCHANT_TRANSACTION: 'MANAGE_MERCHANT_TRANSACTION',
  VIEW_PARTNER_VISIBILITY: 'VIEW_PARTNER_VISIBILITY',
  VIEW_REQUEST_TECH_SUPPORT: 'VIEW_REQUEST_TECH_SUPPORT',
  MANAGE_REQUEST_TECH_SUPPORT: 'MANAGE_REQUEST_TECH_SUPPORT',
  VIEW_USERS: 'VIEW_USERS',
  MANAGE_USERS: 'MANAGE_USERS',
  VIEW_PAYMENT_POLICIES: 'VIEW_PAYMENT_POLICIES',
  CREATE_PAYMENT_POLICIES: 'CREATE_PAYMENT_POLICIES',
  MANAGE_PAYMENT_POLICIES: 'MANAGE_PAYMENT_POLICIES',
};

export const PermissionMappingsV2 = {
  'merchants.view': PermissionsV2.VIEW_MERCHANTS,
  'merchants.merchant_information.view': PermissionsV2.VIEW_MERCHANT_INFORMATION,
  'merchants.merchant_information.edit': PermissionsV2.EDIT_MERCHANT_INFORMATION,
  'merchants.kyc_documents.view': PermissionsV2.VIEW_KYC_DOCUMENTS,
  'merchants.corridor_management.view': PermissionsV2.VIEW_MERCHANT_CORRIDOR_MANAGEMENT,
  'merchants.corridor_management.manage': PermissionsV2.MANAGE_MERCHANT_CORRIDOR_MANAGEMENT,
  'merchants.corridor_management.create': PermissionsV2.CREATE_MERCHANT_CORRIDOR_MANAGEMENT,
  'account_configs.add_account.view': PermissionsV2.VIEW_ADD_ACCOUNT_ACCOUNT_CONFIGS,
  'account_configs.add_account.create': PermissionsV2.CREATE_ADD_ACCOUNT_ACCOUNT_CONFIGS,
  'account_configs.corridors.view': PermissionsV2.VIEW_CORRIDORS_ACCOUNT_CONFIGS,
  'account_configs.corridors.manage': PermissionsV2.MANAGE_CORRIDORS_ACCOUNT_CONFIGS,
  'account_configs.post_onboard_entity.view': PermissionsV2.VIEW_POST_ONBOARDING_ACCOUNT_CONFIGS,
  'account_configs.post_onboard_entity.manage': PermissionsV2.MANAGE_POST_ONBOARDING_ACCOUNT_CONFIGS,
  'operations.ops.view': PermissionsV2.VIEW_OPS_OPERATIONS,
  'operations.unmapped_credits.view': PermissionsV2.VIEW_UNMAPPED_CREDITS_OPERATIONS,
  'operations.unmapped_credits.approve': PermissionsV2.APPROVE_UNMAPPED_CREDITS_OPERATIONS,
  'operations.whitelist_resources.view': PermissionsV2.VIEW_WHITELIST_RESOURCES_OPERATIONS,
  'operations.whitelist_resources.manage': PermissionsV2.MANAGE_WHITELIST_RESOURCES_OPERATIONS,
  'operations.place_an_otc_trade.create': PermissionsV2.CREATE_PLACEMENT_ORDERS_OPERATIONS,
  'operations.settlement_reports.view': PermissionsV2.VIEW_SETTLEMENT_REPORTS_OPERATIONS,
  'operations.supermerchant_config.view': PermissionsV2.VIEW_SUPERMERCHANT_CONFIG_OPERATIONS,
  'operations.supermerchant_kyb.create': PermissionsV2.CREATE_SUPERMERCHANT_KYB_CONFIG_OPERATIONS,
  'compliance_ops.kyc.view': PermissionsV2.VIEW_KYC_COMPLIANCE_OPERATIONS,
  'compliance_ops.kyc.manage': PermissionsV2.MANAGE_KYC_COMPLIANCE_OPERATIONS,
  'compliance_ops.kyb.view': PermissionsV2.VIEW_KYB_COMPLIANCE_OPERATIONS,
  'compliance_ops.kyb.manage': PermissionsV2.MANAGE_KYB_COMPLIANCE_OPERATIONS,
  'compliance_ops.credit_transactions.credits_in_review.view':
    PermissionsV2.VIEW_CREDITS_IN_REVIEW_COMPLIANCE_OPERATIONS,
  'compliance_ops.credit_transactions.credits_in_review.approve':
    PermissionsV2.APPROVE_CREDITS_IN_REVIEW_COMPLIANCE_OPERATIONS,
  'compliance_ops.credit_transactions.credits_rfi_requested.view':
    PermissionsV2.VIEW_CREDITS_RFI_REQUESTED_COMPLIANCE_OPERATIONS,
  'compliance_ops.debit_transactions.debit_pending_transactions.view':
    PermissionsV2.VIEW_DEBIT_TRANSACTIONS_COMPLIANCE_OPERATIONS,
  'compliance_ops.debit_transactions.debit_rfi_requested_transactions.view':
    PermissionsV2.VIEW_DEFIT_RFI_REQUESTED_COMPLIANCE_OPERATIONS,
  'compliance_ops.transactions_with_risk.view': PermissionsV2.VIEW_TRANSACTION_RISKS_COMPLIANCE_OPERATIONS,
  'compliance_ops.transactions_with_risk.manage': PermissionsV2.MANAGE_TRANSACTION_RISKS_COMPLIANCE_OPERATIONS,
  'payments.view': PermissionsV2.VIEW_PAYMENTS,
  'payments.approve': PermissionsV2.APPROVE_PAYMENTS,
  'payments.create': PermissionsV2.CREATE_PAYMENTS,
  'partner_visibility.view': PermissionsV2.VIEW_PARTNER_VISIBILITY,
  'request_tech_support.view': PermissionsV2.VIEW_REQUEST_TECH_SUPPORT,
  'request_tech_support.manage': PermissionsV2.MANAGE_REQUEST_TECH_SUPPORT,
  'users.view': PermissionsV2.VIEW_USERS,
  'users.manage': PermissionsV2.MANAGE_USERS,
  'payment_policies.view': PermissionsV2.VIEW_PAYMENT_POLICIES,
  'payment_policies.create': PermissionsV2.CREATE_PAYMENT_POLICIES,
  'payment_policies.manage': PermissionsV2.MANAGE_PAYMENT_POLICIES,
  'merchants.transaction.manage': PermissionsV2.MANAGE_MERCHANT_TRANSACTION,
};

export const PERMISSION_NAMES = {
  PAYMENTS_APPROVE: 'payments.approve',
};

export const ACCESS_SCOPES = {
  MERCHANTS: 'merchant',
};
